import { NavLink, Outlet } from "react-router-dom";

const ChurchesTab = () => {
  return (
    <>
      <nav>
        <NavLink to="/create?id"></NavLink>
        <NavLink to="/view"></NavLink>
        <NavLink to="/:churchId"></NavLink>
      </nav>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default ChurchesTab;
